module.exports = __webpack_public_path__ + "static/media/left-arrow-blue.ac37b7b9.svg";